import BaseClass from 'application/BaseClass';
import utilsComponent from 'utils/component';
import FooterSocialButtonsVm from 'vms/socialButtons/FooterSocialButtonsVm';
import FooterSocialButtonsView from 'views/socialButtons/FooterSocialButtonsView';

class FooterSocialButtonsController extends BaseClass {

  constructor(options = {}){
    super(options);
    this.vm = FooterSocialButtonsVm.create(options);
  }
}

export default utilsComponent.make(FooterSocialButtonsController, FooterSocialButtonsView);


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/socialButtons/footerSocialButtonsComponent.js